import React from "react";
import { type Breakpoint, orderedBreakpoints, breakpoints } from "./types";

function getCurrentBreakpoint(): Breakpoint {
  const width = window.innerWidth;
  for (let i = orderedBreakpoints.length - 1; i >= 0; i--) {
    const bp = orderedBreakpoints[i];

    if (width >= breakpoints[bp]) {
      return bp;
    }
  }

  return "sm"; // fallback
}

function useBreakpoints() {
  const [current, setCurrent] = React.useState<Breakpoint>(() =>
    getCurrentBreakpoint(),
  );

  React.useEffect(() => {
    const mediaQueries = orderedBreakpoints.map((bp, index) => {
      const min = breakpoints[bp];
      const mq = window.matchMedia(`(min-width: ${min}px)`);

      const handler = () => {
        setCurrent(getCurrentBreakpoint());
      };

      mq.addEventListener("change", handler);

      return { mq, handler };
    });

    return () => {
      for (const { mq, handler } of mediaQueries) {
        mq.removeEventListener("change", handler);
      }
    };
  }, []);

  return current;
}

export default useBreakpoints;
